<template>
  <div>
    <v-data-table
      disable-pagination
      style="width: 100%"
      :headers="headers"
      :items="driverSignupEntries"
      :pagination.sync="pagination"
      :hide-default-footer="true"
    >
      <template v-slot:item="props">
        <tr>
          <td style="width:2%;">
            <img
              style="margin-top: 6px;"
              height="48"
              width="48"
              alt
              :src="props.item.driverSignupDetails.pictureURL"
              onerror="this.style.display='none'"
            />
          </td>
          <td style="width:7%;">
            {{props.item.user.name}}
            <v-chip class="pa-1" x-small color="blue" v-if="isNewApplication(props.item.addedDate)" text-color="white">
              <v-icon x-small>mdi-star-circle</v-icon>
              new
            </v-chip>
          </td>
          <td style="width:7%;">
            <a
              v-on:click.stop="doNothing()"
              :href="'tel:'+formatNumber(props.item.user.contactNumber)"
            >{{ props.item.user.contactNumber }}</a>
          </td>
          <td style="width:10%;">
            <a
              v-on:click.stop="doNothing()"
              :href="'mailto:'+(props.item.user.email)"
            >{{ props.item.user.email }}</a>
          </td>
          <td
            style="width:10%;"
          >{{ props.item.taxiSignupInformation.colour + ' ' + props.item.taxiSignupInformation.make + ' ' + props.item.taxiSignupInformation.model}}</td>
          
          <td style="width:5%;">{{ props.item.taxiSignupInformation.registrationNumber }}</td>
          <td style="width:3%;">{{ props.item.taxiSignupInformation.numSeats }}</td>
          <td style="width:10%;">{{ applicationStatus(props.item) }}</td>
          <td style="width:10%;">{{ props.item.addedDate }}</td>
          <td style="width:5%;">
            <v-btn
              class="text-none"
              small
              v-on:click.stop="goToDriverApplication(props.item.user.id)"
            >View</v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { replaceStart } from "@/components/util/PhoneNumbers.js";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

import AttributesForTaxiCell from "@/components/widget/AttributesForTaxiCell.vue";
import moment from 'moment'

export default {
  name: "driver_summary_list",
  components: {
    AttributesForTaxiCell
  },
  props: {
    driverSignupEntries: Array,
    paginationProp: Object
  },
  data: function() {
    return {
      rideTypes: [],
      pagination: this.paginationProp,
      headers: [
        {
          text: "",
          align: "left",
          sortable: false,
          value: "picture"
        },
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Contact Number",
          align: "left",
          sortable: false,
          value: "contact_number"
        },
        {
          text: "Email",
          align: "left",
          sortable: false,
          value: "email"
        },
        {
          text: "Vehicle",
          align: "left",
          sortable: false,
          value: "capabilities"
        },
        {
          text: "REG",
          align: "left",
          sortable: false,
          value: "taxi"
        },
        {
          text: "Seats",
          align: "left",
          sortable: false,
          value: "seats"
        },
        {
          text: "Application Status",
          align: "left",
          sortable: false,
          value: "application_status"
        },
        {
          text: "Created",
          align: "left",
          sortable: false,
          value: "addedDate"
        },
        {
          text: "Actions",
          align: "left",
          sortable: false,
          value: "actions"
        }
      ]
    };
  },
  computed: {},
  methods: {
    isNewApplication(addedOn) {
      let addedDate = moment(addedOn, "YYYY-MM-DD HH:mm:ss");
      let now = moment();
      let diffDays = now.diff(addedDate, "days");
      
      if (diffDays < 7) {
        return true
      } else {
        return false
      }
    },
    applicationStatus: function(dse) {
      if (dse.rejected == null) {
        if (dse.submitted) {
          return "Submitted";
        } else {
          return "In Progress";
        }
      } else {
        if (dse.rejected) {
          return "Rejected";
        } else {
          return "Accepted";
        }
      }
    },
    goToDriverApplication: function(id) {
      this.$router.push(`/drivers/applications/${id}`);
    },
    doNothing: function() {},
    formatNumber: function(number) {
      return replaceStart(number);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

table.v-table tbody tr td {
  height: 19px;
  padding: 2px 3px !important;
}

thead th:not(:first-child) {
  padding: 0 4px;
}

.fixed-booking-table-row {
  overflow: hidden;
  height: 18px;
}
</style>
